import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './SellerInfoStyle.scss';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { GlobalHistory  , checkIsColumnHiddenInConfig} from '../../../../../../Helper';
import { ActiveItemActions } from '../../../../../../store/ActiveItem/ActiveItemActions';

export const SellerInfo = ({ parentTranslationPath, translationPath, leadOwner }) => {
  const { t } = useTranslation([parentTranslationPath, 'Shared']);
  const dispatch = useDispatch();
  const moveToContact = () => {
    if (leadOwner) {
      dispatch(ActiveItemActions.activeItemRequest({ name: leadOwner.contactName, id: leadOwner.contactId }));
      GlobalHistory.push(
        `/home/Contacts-CRM/contact-profile-edit?formType=${leadOwner.contactsTypeId}&id=${leadOwner.contactId}`
      );
    }
  };

  const moveToLead = () => {
     if (leadOwner)
     dispatch(ActiveItemActions.activeItemRequest({ id: leadOwner.leadId, name: leadOwner.contactName }));
     const leadClass = leadOwner && leadOwner.leadClass && (leadOwner.leadClass === 'Seller' || leadOwner.leadClass === 'Landlord') ? 1 : 2;
     GlobalHistory.push(
      `/home/lead-sales/lead-profile-edit?formType=${leadClass}&id=${leadOwner.leadId}&leadClass=${leadOwner.leadClass}`
     );
  };

  return (
    <div className='sellerInfo'>
      <div className='card'>
        <div>
          <span className='titleSection'>
            {t('sellerInformation')}
          </span>
        </div>
        <div className='sellerInfoContant'>
          <div className='sectionItem'>
            <span className='mdi mdi-account-tie  mr-1' />
            <span className='headtitle mr-1'>{`${t('lead-name')} : `}</span>
            {' '}
            {leadOwner && leadOwner.contactName ? (
              <a href='# ' onClick={() => moveToContact()}>
                <span className='navbar-item' activeClassName='is-active'>
                  {(leadOwner && leadOwner.contactName)}
                </span>
              </a>
            ) : 'N/A'}

          </div>

          <div className='sectionItem'>
            <span className='mdi mdi-clipboard-account mr-1' />
            <span className='headtitle mr-1'>{`${t('lead-ID')} : `}</span>
            {' '}
            { leadOwner && leadOwner.leadId ? (
              <a href='# ' onClick={() => moveToLead()}>
                <span className='navbar-item' activeClassName='is-active'>
                  {(leadOwner && leadOwner.leadId)}
                  {' '}
                </span>
              </a>
            ) : 'N/A'}
          </div>

          <div className='sectionItem'>
            <span className='mdi mdi-phone  mr-1' />
            <span className='headtitle mr-1'>{`${t('lead-phone')} : `}</span>
            {' '}
            {(leadOwner && leadOwner.phone) || 'N/A' }
          </div>
          <div className='sectionItem'>
            <span className='mdi mdi-email-outline  mr-1'> </span>
            <span className='headtitle mr-1'>{`${t('lead-email')} : `}</span>
            {' '}
            {(leadOwner && leadOwner.email) || 'N/A' }
          </div>
          <div className='sectionItem'>
            <span className='mdi mdi-comment-check-outline  mr-1'> </span>
            <span className='headtitle mr-1'>{`${t('consent-main')} : `}</span>
            {' '}
            {
                (leadOwner && leadOwner.mainConsentName) || 'N/A'
            }
          </div>
          {
            !checkIsColumnHiddenInConfig({ columnName: 'assetsConsent' }) && 
            (
              <div className='sectionItem'>
              <span className='mdi mdi-comment-check-outline mr-1'> </span>
              <span className='headtitle mr-1'>{`${t('consent-assets')} : `}</span>
              {' '}
              {
                  (leadOwner && leadOwner.assetsConsentName) || 'N/A'
              }
            </div>
          )}
          <div className='sectionItem'>
            <span className='mdi mdi-comment-plus-outline  mr-1'> </span>
            <span className='headtitle mr-1'>{`${t('dncr')} : `}</span>
            {' '}
            {
                (leadOwner && leadOwner.dncrName) || 'N/A'
            }
          </div>

        </div>

      </div>
    </div>
  );
};

SellerInfo.propTypes = {
  parentTranslationPath: PropTypes.string.isRequired,
  translationPath: PropTypes.string.isRequired,
  leadOwner: PropTypes.instanceOf(Object).isRequired,
};
